import { Box, IconButton, Stack, Tooltip } from "@mui/material"
import { ExportStatus } from "./components/ExportStatusDialog"
import AlertBadge from "components/UI/AlertBadge/AlertBadge"
import ResetFiltersIcon from 'components/UI/icons/ResetFiltersIcon'
import COLORS from 'lib/colors'
import RefreshIcon from '@mui/icons-material/Refresh'
import UploadIcon from '@mui/icons-material/FileUploadOutlined'
import DownloadIcon from '@mui/icons-material/FileDownloadOutlined'
import DownloadingIcon from '@mui/icons-material/Downloading'

type LeadsPageToolbarProps = {
  onResetFilters: () => void
  onExport: () => void
  onImport: () => void
  onRefresh: () => void

  exportStatus: ExportStatus | null
  permitUpload: boolean
  loading: boolean
}

export function LeadsPageToolbar({
  onResetFilters,
  onExport,
  onImport,
  onRefresh,
  exportStatus,
  permitUpload,
  loading,
}: LeadsPageToolbarProps) {
  const exportCsvIcon =
    <Box sx={{position: 'relative', height: '24px'}}>
      {!!exportStatus && (exportStatus.status === 'running' || exportStatus.status === 'queued') && (
        <Box sx={{ position: 'absolute', left: '-10px', top: '-10px'}}>
          <Tooltip title='Click for Status Update'>
              <div>
                <DownloadingIcon style={{ color: COLORS.coastalWaters, display: 'block' }}/>
              </div>
          </Tooltip>
        </Box>
      )}
      {!!exportStatus && exportStatus.status === 'discarded' && (
        <AlertBadge tipTitle='Error' sx={{left: '-10px', top: '-11px'}}/>
      )}
      {!!exportStatus && exportStatus.status === 'succeeded' && (
        <AlertBadge variant='success' tipTitle='Success' sx={{left: '-10px', top: '-11px'}}/>
      )}
      <DownloadIcon />
    </Box>

  return (
    <Stack direction='row' sx={{ svg: { color: COLORS.frenchBlue } }}>
      <Tooltip title='Reset Filters'>
        <IconButton
          aria-label='Reset Filters'
          onClick={onResetFilters}
        >
          <ResetFiltersIcon />
        </IconButton>
      </Tooltip>

      <Tooltip title='Export CSV'>
        <IconButton
          aria-label='Export CSV'
          onClick={onExport}
        >
          {exportCsvIcon}
        </IconButton>
      </Tooltip>

      {permitUpload && (
        <Tooltip title='Import CSV'>
          <IconButton
            aria-label='Import CSV'
            onClick={onImport}
          >
            <UploadIcon />
          </IconButton>
        </Tooltip>
      )}

      <Tooltip title='Refresh'>
        <IconButton
          aria-label='Refresh'
          onClick={onRefresh}
          disabled={loading}
        >
          <RefreshIcon />
        </IconButton>
      </Tooltip>
    </Stack>
  )
}
